{
  "version": 1,
  "asset_id": "367b76c2-7787-42b0-baba-c5b649cc8995",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/367b76c2-7787-42b0-baba-c5b649cc8995/palworld-collector-figure-set.jpg",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/367b76c2-7787-42b0-baba-c5b649cc8995/palworld-collector-figure-set.jpg",
  "original_filename": "palworld-collector-figure-set.jpg",
  "size": 51549,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T19:00:56Z"
}
